import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// Constants - Functions
import { WEB_SERVICE_MIMS, protocols } from "../../../../config/constants";
// Components
import { MainDiv } from "./styles";
import UseFetch from "../../../../config/useFetch";
import Loader from "../../../loader";
import Title from "../../../title";
import DiagnosticAssessments from "./sections/diagnosticAssessments";
import RecentDiagnosticAssessment from "./sections/recentDiagnosticAssessment";
import DiagnosticAssessmentsPlot from "./sections/diagnosticAssessmentsPlot";

const Diagnostics = ({
  startingDate,
  prescribedDayThisWeek,
  diagnosticDates,
  newDiagnosticDate,
  setNewDiagnosticDate,
  diagnosticNumber,
  setDiagnosticNumber,
  diagnosticId,
  setDiagnosticId,
  showDiagnosticDatePopup,
  setShowDiagnosticDatePopup,
  refreshDiagnosticDates,
  setRefreshDiagnosticDates,
}) => {
  const [qualityControlSessions, setQualityControlSessions] = useState([]);
  const [constellationsSessions, setConstellationsSessions] = useState([]);
  const [isLoadingRecordings, setIsLoadingRecordings] = useState(true);
  const { patientId } = useParams();

  // Fetch Protocol Recordings
  useEffect(() => {
    UseFetch("get", `${WEB_SERVICE_MIMS}/reports/software/get/${patientId}/plus`)
      .then(({ data }) => {
        const qualityControlSessions = data
          .filter((session) => session.PROTOCOL_ID === protocols.app.basic.QUALITY_CONTROL_BASIC.id)
          .sort((a, b) => (new Date(a.STARTING_DATE) < new Date(b.STARTING_DATE) ? -1 : 1));

        const constellationsSessions = data
          .filter((session) => session.PROTOCOL_ID === protocols.app.basic.CONSTELLATIONS.id)
          .sort((a, b) => (new Date(a.STARTING_DATE) < new Date(b.STARTING_DATE) ? -1 : 1));

        setQualityControlSessions(qualityControlSessions);
        setConstellationsSessions(constellationsSessions);

        setIsLoadingRecordings(false);
      })
      .catch((error) => {
        console.log("Get recordings: ", error);
      });

    return () => {
      setQualityControlSessions([]);
      setConstellationsSessions([]);
      setIsLoadingRecordings(true);
    };
  }, [patientId]);

  return (
    <>
      <Title title={"DIAGNOSTICS"} marginBottom="15px" />
      {isLoadingRecordings ? (
        <Loader height={50} />
      ) : (
        <MainDiv>
          <DiagnosticAssessments
            startingDate={startingDate}
            prescribedDayThisWeek={prescribedDayThisWeek}
            diagnosticDates={diagnosticDates}
            newDiagnosticDate={newDiagnosticDate}
            setNewDiagnosticDate={setNewDiagnosticDate}
            diagnosticNumber={diagnosticNumber}
            setDiagnosticNumber={setDiagnosticNumber}
            diagnosticId={diagnosticId}
            setDiagnosticId={setDiagnosticId}
            showDiagnosticDatePopup={showDiagnosticDatePopup}
            setShowDiagnosticDatePopup={setShowDiagnosticDatePopup}
            refreshDiagnosticDates={refreshDiagnosticDates}
            setRefreshDiagnosticDates={setRefreshDiagnosticDates}
          />
          <RecentDiagnosticAssessment qualityControlSessions={qualityControlSessions} constellationsSessions={constellationsSessions} />
          <DiagnosticAssessmentsPlot
            sessions={qualityControlSessions}
            protocolFunction="Executive Function"
            protocolTitle="(Quality Control)"
          />
          <DiagnosticAssessmentsPlot
            sessions={constellationsSessions}
            protocolFunction="Memory Function"
            protocolTitle="(Constellations)"
          />
        </MainDiv>
      )}
    </>
  );
};

export default Diagnostics;
